const AllProducts = [
  {
    id: 55,
    type: "Sanduíches Tradiconais",
    name: "Hambúrguer",
    image: "sanduiche_1.jpg",
    info: "Pão, Hambúrguer 60g, batata palha, alface, tomate e creme de maionese",
    price: "R$9,50"
  }, {
    id: 1,
    type: "Sanduíches Tradiconais",
    name: "X Burguer",
    image: "sanduiche_1.jpg",
    info: "Pão, Hambúrguer 60g, Queijo, alface, tomate e creme de maionese",
    price: "R$12,50"
  }, {
    id: 2,
    type: "Sanduíches Tradiconais",
    name: "X Burguer Egg",
    image: "sanduiche_1.jpg",
    info: "Pão, Hambúrguer 60g, Queijo, Ovo, alface, tomate e creme de maionese",
    price: "R$13,50"
  }, {
    id: 3,
    type: "Sanduíches Tradiconais",
    name: "X Bacon",
    image: "sanduiche_1.jpg",
    info: "Pão, Creme de maionese, Hambúrguer 60g, Queijo, Bacon, alface, tomate e creme de maionese",
    price: "R$14,00"
  }, {
    id: 4,
    type: "Sanduíches Tradiconais",
    name: "X Bacon Egg",
    image: "sanduiche_1.jpg",
    info: "Pão, Creme de maionese, Hambúrguer 60g, Queijo, Bacon,alface, tomate e creme de maionese",
    price: "R$15,00"
  }, {
    id: 5,
    type: "Sanduíches Tradiconais",
    name: "Laçador",
    image: "sanduiche_1.jpg",
    info: "Pão, Hambúrguer 60g, Presunto, Queijo, Bacon, Milho, Batata Palha, alface, tomate e creme de maionese",
    price: "R$17,00"
  }, {
    id: 6,
    type: "Sanduíches Tradiconais",
    name: "Misto Quente",
    image: "sanduiche_1.jpg",
    info: "Pão de forma, 2 presunto e 2 queijo",
    price: "R$7,00"
  }, {
    id: 7,
    type: "Sanduíches Especiais",
    name: "Chicken Burguer",
    image: "sanduiche_1.jpg",
    info: "Pão, Hambúrguer de frango 60g, queijo, ovo, milho batata palha,alface, tomate e creme de maionese",
    price: "R$17,50"
  }, {
    id: 8,
    type: "Sanduíches Especiais",
    name: "Sãoduíche",
    image: "sanduiche_1.jpg",
    info: "Pão, Hambúrguer 60g, queijo, presunto, ovo, bacon, milho, batata palha, alface, tomate e creme de maionese",
    price: "R$17,50"
  }, {
    id: 9,
    type: "Sanduíches Especiais",
    name: "Frango Tudo",
    image: "sanduiche_1.jpg",
    info: "Pão, frango desfiado, queijo, presunto, ovo, bacon, milho. batata palha,alface, tomate e creme de maionese",
    price: "R$18,80"
  }, {
    id: 10,
    type: "Sanduíches Especiais",
    name: "Frango Cheddar",
    image: "sanduiche_1.jpg",
    info: "Pão, frango desfiado, cheddar, queijo, alface, tomate e creme de maionese",
    price: "R$15,50"
  }, {
    id: 11,
    type: "Sanduíches Especiais",
    name: "Frango Bacon",
    image: "sanduiche_1.jpg",
    info: "Pão, frango desfiado, bacon, queijo, azeitona preta, alface, tomate e creme de maionese",
    price: "R$16,50"
  }, {
    id: 12,
    type: "Sanduíches Especiais",
    name: "Frango Catupiry",
    image: "sanduiche_1.jpg",
    info: "Pão, frango desfiado, catupiry, milho, batata palha, alface, tomate e creme de maionese",
    price: "R$17,50"
  }, {
    id: 13,
    type: "Sanduíches Especiais",
    name: "Gulosão",
    image: "sanduiche_1.jpg",
    info: "Pão, Hambúrguer 60g, frango desfiado,queijo, presunto, ovo, bacon, catupiry, milho. batata palha, alface, tomate e creme de maionese",
    price: "R$23,00"
  }, {
    id: 14,
    type: "Turma da Picanha",
    name: "Gulosão Mega Picanha",
    image: "sanduiche_1.jpg",
    info: "Pão, hambúrguer picanha 200g, frango desfiado, queijo, presunto, ovo, bacon, milho, batata palha, alface, tomate e creme de maionese",
    price: "R$29,00"
  }, {
    id: 15,
    type: "Turma da Picanha",
    name: "Sãodubinha Picanha",
    image: "sanduiche_1.jpg",
    info: "Pão, hambúrguer picanha 120g, queijo, ovo, milho, alface, tomate e creme de maionese",
    price: "R$19,00"
  }, {
    id: 16,
    type: "Turma da Picanha",
    name: "Sãoduíche Picanha",
    image: "sanduiche_1.jpg",
    info: "Pão, hambúrguer picanha 120g, queijo, presunto, ovo, bacon, milho, batata palha, alface, tomate e creme de maionese",
    price: "R$21,50"
  }, {
    id: 17,
    type: "Turma da Picanha",
    name: "Gulosão Picanha",
    image: "sanduiche_1.jpg",
    info: "Pão, Hambúrguer picanha 120 gr, Frango desfiado, queijo, presunto, ovo, bacon, milho, batata palha, alface, tomate e creme de maionese",
    price: "R$24,50"
  }, {
    id: 18,
    type: "Turma da Picanha",
    name: "Sãoduíche Mega Picanha",
    image: "sanduiche_1.jpg",
    info: "Pão, hambúrguer picanha 200g, queijo, presunto, ovo, bacon, milho, batata palha, alface, tomate e creme de maionese",
    price: "R$28,50"
  }, {
    id: 19,
    type: "Turma do Greladão",
    name: "Sãodubinha grelhadão",
    image: "sanduiche_1.jpg",
    info: "Pão, hambúrguer picanha 170 g, 2 queijos, 2 bacons, alface, tomate e creme de maionese",
    price: "R$25,50"
  }, {
    id: 20,
    type: "Turma do Greladão",
    name: "Sãoduiche Grelhadão",
    image: "sanduiche_1.jpg",
    info: "Pão, hambúrguer picanha 170 g, queijo, bacon, presunto, ovo, milho, batata palha, alface, tomate e creme de maionese",
    price: "R$27,50"
  }, {
    id: 21,
    type: "Turma do Greladão",
    name: "Gulosão Grelhadão",
    image: "sanduiche_1.jpg",
    info: "Pão, hambúrguer picanha 170 g, frango desfiado, queijo, bacon, presunto, ovo, milho, batata palha, alface, tomate e creme de maionese",
    price: "R$29,50"
  }, {
    id: 22,
    type: "Combos",
    name: "Combo Super",
    image: "sanduiche_1.jpg",
    info: "1 Sãoduíche + 1 Barca de Batatas Fritas + 1 Refrigerante Lata ou suco Lata Pão, Hambúrguer 60g, Queijo, Presunto, Bacon, Ovo, Milho, Batata Palha, alface, tomate e creme de maionese",
    price: "R$30,00"
  }, {
    id: 23,
    type: "Combos",
    name: "Combo Mega",
    image: "sanduiche_1.jpg",
    info: "1 Sãoduíche Picanha + 1 Barca de Batatas Fritas + 1 Refrigerante Lata ou suco Lata Pão, Hambúrguer 120g, Queijo, Presunto, Bacon, Ovo, Milho, Batata Palha, alface, tomate e creme de maionese",
    price: "R$34,00"
  }, {
    id: 24,
    type: "Combos",
    name: "Combo Maxi",
    image: "sanduiche_1.jpg",
    info: "	1 Gulosão Grelhado + 1 Barca de Batatas Fritas + 1 Refrigerante Lata ou suco Lata Pão, Hambúrguer Picanha 170g, Frango Desfiado, Queijo, Presunto, Bacon, Ovo, Milho, Batata Palha, alface, tomate e creme de maionese",
    price: "R$39,50"
  }, {
    id: 25,
    type: "Combos",
    name: "Combo Kids",
    image: "sanduiche_1.jpg",
    info: "1 X-Burguer + 1 Barca de Batatas Fritas + 1 Refrigerante Lata ou suco Lata Pão, Hambúrguer 60g, Queijo, alface, tomate e creme de maionese",
    price: "R$26,50"
  }, {
    id: 26,
    type: "Combos",
    name: "Combo Casal",
    image: "sanduiche_1.jpg",
    info: "2 X- Bacon Egg + 2 Refrigerante Lata ou Suco Lata - Pão, Creme de maionese, Hambúrguer 60g, Queijo, Bacon, alface, tomate e creme de maionese",
    price: "R$35,50"
  }, {
    id: 27,
    type: "Combos",
    name: "Combo Família",
    image: "sanduiche_1.jpg",
    info: "2 Sãoduíches + 1 Refrigerante Grande + 1 barca de Batatas Fritas - Pão, hambúrguer 60 g, queijo, bacon, presunto, ovo, milho, batata palha,alface, tomate e creme de maionese",
    price: "R$51,00"
  }, {
    id: 28,
    type: "Combos",
    name: "Combo Super Família",
    image: "sanduiche_1.jpg",
    info: "Super Família: 3 Sãoduíches picanha + 1 Refrigerante Grande + 2 barcas de Batatas Fritas - Pão, hambúrguer picanha 120 g, queijo, bacon, presunto, ovo, milho, batata palha, alface, tomate e creme de maionese",
    price: "R$82,00"
  }, {
    id: 29,
    type: "Combos",
    name: "Combo Galera",
    image: "sanduiche_1.jpg",
    info: "5 Sãoduíches+ 1 Refrigerante Grande + 3 barcas de Batatas Fritas - Pão, hambúrguer 60 g, queijo, bacon, presunto, ovo, milho, batata palha, alface, tomate e creme de maionese",
    price: "R$115,00"
    }, {
    id: 43,
    type: "Porções",
    name: "Barca Batata Frita",
    image: "sanduiche_1.jpg",
    info: null,
    price: "R$12,00"
  }, {
    id: 44,
    type: "Porções",
    name: "1/2 Barca Batata Frita",
    image: "sanduiche_1.jpg",
    info: null,
    price: "R$7,50"
  }, {
    id: 45,
    type: "Porções",
    name: "Nuguets 08 unidades",
    image: "sanduiche_1.jpg",
    info: null,
    price: "R$12,00"
  }, {
    id: 46,
    type: "Porções",
    name: "Nuguets 04 unidades",
    image: "sanduiche_1.jpg",
    info: null,
    price: "R$7,50"
  }, {
    id: 47,
    type: "Bebidas",
    name: "Refri lata 350ml",
    image: "sanduiche_1.jpg",
    info: "Coca comum, coca zero, Guaraná Antarctica comum, Guaraná Antarctica zero, Fanta Laranja, Fanta Uva, Sprite, Schweppes",
    price: "R$5,00"
  }, {
    id: 48,
    type: "Bebidas",
    name: "Suco Lata 290ml",
    image: "sanduiche_1.jpg",
    info: "Manga, pessego, Maracujá, Uva e Goiaba",
    price: "R$5,00 "
  }, {
    id: 49,
    type: "Bebidas",
    name: "Refrigerante 2 l",
    image: "sanduiche_1.jpg",
    info: "Coca comum, coca zero, Guaraná Antarctica comum, Guaraná Antarctica zero, Fanta Laranja, Guarapan, Sprite",
    price: "R$10,00"
  }, {
    id: 50,
    type: "Bebidas",
    name: "Agua Tônica",
    image: "sanduiche_1.jpg",
    info: "Schweppes",
    price: "R$5,00"
  }, {
    id: 51,
    type: "Bebidas",
    name: "Agua Mineral S/ Gás",
    image: "sanduiche_1.jpg",
    info: null,
    price: "R$2,50"
  }, {
    id: 52,
    type: "Bebidas",
    name: "Agua Mineral C/ Gás",
    image: "sanduiche_1.jpg",
    info: null,
    price: "R$3,00"
  }, {
    id: 53,
    type: "Bebidas",
    name: "Cerveja Latão 473ml",
    image: "sanduiche_1.jpg",
    info: "	Brahma, Skol",
    price: "R$6,00"
  }, {
    id: 54,
    type: "Bebidas",
    name: "Cerveja Long Neck",
    image: "sanduiche_1.jpg",
    info: "Budweiser, Heineken",
    price: "R$7,00"
  },
]

export default AllProducts;